import { HTMLAttributes } from "react";
import "./styles.css";

import { ReactComponent as GrassIcon } from "../../../assets/svg/icons/grass.svg";
import { ReactComponent as AreaIcon } from "../../../assets/svg/icons/areaIcon.svg";
import { ReactComponent as FarmIcon } from "../../../assets/svg/icons/farmIcon.svg";

type MicroAreaSpecsProps = HTMLAttributes<HTMLDivElement> & {
  microAreaLabel: string;
  type: "farm" | "area" | "batch";
  capacity?: string;
};

export function SpecsMouseOver({ microAreaLabel, type, capacity, ...rest }: MicroAreaSpecsProps) {
  return (
    <section className={`microareaSpecs__container ${rest.className}`}>
      <div className="microareaSpecs__microarea">
        {type=="farm"?(<FarmIcon/>):(<></>)}
        {type=="area"?(<AreaIcon/>):(<></>)}
        {type=="batch"?(<GrassIcon/>):(<></>)}
        <h3>{microAreaLabel}</h3>
      </div>
      {capacity && (
        <div className="microareaSpecs__capacity">
          <h3 className="capacity">{capacity} UA/HA</h3>
        </div>
      )}
    </section>
  );
}
